import { useContext } from 'react'
import { FieldValues } from 'react-hook-form'

import { SwitchProps } from 'components/Form/Switch'
import Paper from 'components/Paper'
import { InventoryAmazonUamTamSectionHeader } from 'features/globalSetup/features/amazon/components/InventoryAmazonUamTamSectionHeader'
import { useInventoryAmazonUamTamSwitchProps } from 'features/globalSetup/features/amazon/hooks/useInventoryAmazonUamTamSwitchProps'
import { AddEditAdUnitContext } from 'features/inventory/ad-unit/contexts/AddEditAdUnitContext'
import { cypressId } from 'features/inventory/ad-unit/forms/PrebidStackForm/utils'
import { DomainPrebidStack } from 'features/inventory/domain/types/domainPrebidStack'
import { DomainAmazonAlerts } from './DomainAmazonAlerts'
import { useGetAdUnitAmazonAlerts } from './useGetAdUnitAmazonAlerts/useGetAdUnitAmazonAlerts'

export type Props = {
  amazonState: DomainPrebidStack['domainAmazonEnabled']
}

export const InventoryAmazonUamTamSection = <Schema extends FieldValues>({
  amazonState,
}: Props): React.JSX.Element => {
  const { adUnit } = useContext(AddEditAdUnitContext)

  if (adUnit === undefined) {
    throw Error('Ad unit should be accessible')
  }

  const switchProps: SwitchProps<Schema> = useInventoryAmazonUamTamSwitchProps<Schema>({
    amazonState,
    feature: 'adUnit',
  })

  const { alerts } = useGetAdUnitAmazonAlerts({ adUnitAmazonId: adUnit.adUnitAmazon.id })

  return (
    <Paper data-cy={cypressId('amazon-uam-tam')}>
      <InventoryAmazonUamTamSectionHeader
        Alerts={<DomainAmazonAlerts alerts={alerts} />}
        feature='adUnit'
        switchProps={switchProps}
      />
    </Paper>
  )
}
